import PlacesAutocomplete, { geocodeByAddress, getLatLng, } from 'react-places-autocomplete';
import { useTranslation } from "react-i18next";

import {
    TextField as MuiTextField,
    makeStyles,
    MenuItem
} from "@material-ui/core";

import { spacing } from "@material-ui/system";
import styled from "styled-components/macro";
import { useEffect, useState } from 'react';
import { ReactComponent as GradientSearchSVG } from "../vendor/gradient-search.svg"

const TextField = styled(MuiTextField)(spacing);
const useStyles = makeStyles(theme => ({
    wrapper: {
        position: 'relative'
    },
    listItems: {
        position: 'absolute',
        zIndex: 1
    }
}))

const DayWrapper = styled.div`
    box-shadow: 0px 0px 16.9299px rgba(53, 64, 82, 0.05);
    border-radius: 4.83711px;
`;
const DayText = styled.div`
    background: linear-gradient(90deg, #84FAB0 0%, #8FEAFE 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
`;

export const getAddressDataFromSearch = (addressData: any) => {

    if (!addressData) {
        return false
    }

    let addressDataFromSearch: any = {
        address_line_1: "",
        full_address: addressData.formatted_address
    }
    addressData.address_components.forEach((item: any) => {
        if (item.types.includes('route') || item.types.includes('street_number')) {
            addressDataFromSearch.address_line_1 = addressDataFromSearch.address_line_1 + " " + item.short_name
        }
        if (item.types.includes('locality') || item.types.includes('postal_town')) {
            addressDataFromSearch.city = item.long_name
        }
        if (item.types.includes('country')) {
            addressDataFromSearch.country_code = item.short_name
        }
        if (item.types.includes('postal_code')) {
            addressDataFromSearch.postcode = item.short_name
        }
    })
    return addressDataFromSearch
}

export const LocationAutocomplete = (props: {
    onConfirmLocation: (v: {
        addressData: any,
        latLng: google.maps.LatLngLiteral
    }) => void
    value: string
    validAddress: boolean
    fullAddressError?: any;
    isValidAddress: (address_components: google.maps.GeocoderAddressComponent[]) => void
    name?: string
}) => {
    const styles = useStyles()
    const { fullAddressError, name = 'full_address' } = props;
    const [address, setAddress] = useState(props.value ?? "");
    const [touched, setTouched] = useState(false);
    const [addressComponents, setAddressComponents] = useState<google.maps.GeocoderResult>(null!);
    const { t } = useTranslation();
    useEffect(() => {
        setAddress(props.value ?? "");
    }, [props.value]);
    const handleChange = (address: string) => {
        setAddress(address);
    };
    useEffect(() => {
        if (address && !touched) {
            setTouched(true);
        }
        geocodeByAddress(address)
            .then(results => {
                setAddressComponents(results[0]);
            })
            .catch(console.log);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [address]);
    const handleSelect = (address: string) => {
        console.log(address);
        let addressDataFromSearch: google.maps.GeocoderResult = null!;
        geocodeByAddress(address)
            .then(results => {
                addressDataFromSearch = results[0]
                return getLatLng(results[0])
            })
            .then((latLng) => {
                // setAddress(address)
                setAddressComponents(addressDataFromSearch);
                props.isValidAddress(addressDataFromSearch.address_components)
                props.onConfirmLocation({
                    addressData: getAddressDataFromSearch(addressDataFromSearch),
                    latLng
                })

            })
            .catch(error => console.error('Error', error));
    }
    return (
        <PlacesAutocomplete
            value={address}
            onChange={handleChange}
            onSelect={handleSelect}
        >
            {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
                <div className={styles.wrapper}>
                    <TextField
                        name={name}
                        error={(touched || fullAddressError) && (!props.validAddress || !address)}
                        InputProps={{
                            startAdornment: (
                                <DayWrapper>
                                    <DayText>
                                        <GradientSearchSVG />
                                    </DayText>
                                </DayWrapper>),
                        }}
                        {...getInputProps({
                            placeholder: t("LocationAutocomplete_searchPlaceholder"),
                            className: 'location-search-input',
                            fullWidth: true,
                            my: 2,
                            variant: 'outlined',
                            onBlur: (e) => {
                                if (addressComponents) {
                                    setAddress(props.value ?? addressComponents.formatted_address);
                                } else {
                                    setAddress("");
                                }
                            }
                        })}
                        helperText={touched && (!props.validAddress ? `*${t("LocationAutocomplete_validAddress")}` : (
                            !address ? t("LocationAutocomplete_addressEmpty") : null
                        ))}
                    />
                    <div className={styles.listItems}>
                        {suggestions.map((suggestion, index) => {
                            const style = suggestion.active
                                ? { backgroundColor: '#fafafa', cursor: 'pointer', color: "black" }
                                : { backgroundColor: '#ffffff', cursor: 'pointer', color: "black" };
                            return (
                                <MenuItem
                                    {...getSuggestionItemProps(suggestion, {
                                        style,
                                        key: index
                                    })}
                                    key={index}
                                >
                                    {suggestion.description}
                                </MenuItem>
                            );
                        })}
                    </div>
                </div>
            )}
        </PlacesAutocomplete>
    );
}